import React, { useState, useEffect } from "react";
import { Card, Title } from "@mantine/core";

import { AffiliateForm, AffiliateList } from "./";
import { ManagementLayout } from "@components/shared";

export default function AffiliateManagement() {
  const [success, setSuccess] = useState(false);
  const [refresh, setRefresh] = useState(false);

  return (
    <ManagementLayout
      dataComponent={<AffiliateList refresh={refresh} />}
      createComponent={
        <Card
          style={{
            overflow: "visible",
          }}
        >
          <Title order={4}>Create Affiliate</Title>
          {!success && (
            <AffiliateForm
              onSuccess={() => {
                setSuccess(!success);
                setRefresh(!refresh);
                setTimeout(() => {
                  setSuccess(false);
                }, 1);
              }}
            />
          )}
        </Card>
      }
    />
  );
}
